// extracted by mini-css-extract-plugin
module.exports = {"colorInputContainer":"ColorInputBox_colorInputContainer__2hcmK","colorInputField":"ColorInputBox_colorInputField__3SB3c","colorPreviewBox":"ColorInputBox_colorPreviewBox__3RC7p"};